<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="ProfileModalLabel">Profile</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <!-- Row -->
      <div class="row">
        <!-- Column -->
        <div class="col-lg-4 col-xlg-3 col-md-5">
          <div class="card">
            <div class="card-body">
              <center class="mt-4">
                <label class="form-label">Picture ( 300 * 300 px )</label>
                <div class="text-center">
                  <img
                    id="profile_user_preview"
                    class="mt-2 mb-2"
                    width="150"
                    style="max-width: 150px; border-radius: 5px !important;"
                    :src="user.photo || '../../static/img/default-avatar.png'"
                    onerror="if (this.src != '../../static/img/default-avatar.png') this.src = '../../static/img/default-avatar.png'"
                  />
                  <input type="file" name="profile_user" id="profile_user" style="display: none;" data-parsley-id="4" @change="imgPreview" />
                  <br />
                  <label for="profile_user" class="btn btn-info btn-sm btn-block btn-sm-fix m-2"><i class="fa fa-image"></i> Upload</label>
                </div>

                <h4 class="card-title mt-2">{{ user.fullname || 'Not Fullname' }}</h4>
                <h6 class="card-subtitle">{{ user.role_name }}</h6>
              </center>
            </div>
            <div>
              <hr class="m-0" />
            </div>
            <div class="card-body">
              <small class="text-muted">Email address </small>
              <h6>{{ user.email || '-' }}</h6>
              <small class="text-muted pt-4 db">Phone</small>
              <h6>{{ user.phone || '-' }}</h6>
            </div>
          </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-8 col-xlg-9 col-md-7">
          <div class="card">
            <!-- Tabs -->
            <ul class="nav nav-pills custom-pills" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: tab_active === 1 }"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  href="#tab-profile"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  @click="tab_active = 1"
                  ><i class="fas fa-user"></i>&nbsp;&nbsp;&nbsp;Profile</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: tab_active === 2 }"
                  id="pills-setting-tab"
                  data-bs-toggle="pill"
                  href="#tab-password"
                  role="tab"
                  aria-controls="pills-setting"
                  aria-selected="false"
                  @click="tab_active = 2"
                  ><i class="fas fa-key"></i>&nbsp;&nbsp;&nbsp;Password</a
                >
              </li>
            </ul>
            <!-- Tabs -->
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade" :class="{ 'show active': tab_active === 1 }" id="tab-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <div class="card-body">
                  <form class="form-horizontal needs-validation" novalidate id="formProfile">
                    <div class="mb-3">
                      <label class="col-md-12">Username <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="text" class="form-control form-control-fix" v-model="user.username" disabled="true" />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Name <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="text" placeholder="name" v-model="user.name" class="form-control form-control-fix" required />
                      </div>
                      <div class="invalid-feedback">
                        Please enter name.
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Surname <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="text" placeholder="surname" v-model="user.surname" class="form-control form-control-fix" required />
                      </div>
                      <div class="invalid-feedback">
                        Please enter surname.
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Email</label>
                      <div class="col-md-12">
                        <input type="email" placeholder="mail@mail.com" class="form-control form-control-fix" name="email" v-model="user.email" />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Phone</label>
                      <div class="col-md-12">
                        <input type="text" v-mask="'###-###-####'" placeholder="Phone.." v-model="user.phone" class="form-control form-control-fix" />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Section <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="text" placeholder="section.." v-model="user.section" class="form-control form-control-fix" required />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Role <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <select v-model="user.role_id" class="form-control-line form-select" style="width: 100%;" disabled required>
                          <option selected disabled value="">Choose...</option>
                          <option v-for="(r, i) in role_list" :key="'prole' + i" :value="r.r_id">
                            {{ r.r_name }}
                          </option>
                        </select>
                        <div class="invalid-feedback">
                          Please select a valid role.
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="tab-pane fade" :class="{ 'show active': tab_active === 2 }" id="tab-password" role="tabpanel" aria-labelledby="pills-setting-tab">
                <div class="card-body">
                  <form class="form-horizontal needs-validation" novalidate id="formResetPassword">
                    <div class="mb-3">
                      <label class="col-md-12">Old Password <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="password" placeholder="old password..." class="form-control form-control-fix" autocomplete="off" v-model="old_password" required />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">New Password <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="password" placeholder="new password..." class="form-control form-control-fix" autocomplete="off" v-model="new_password" required />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-md-12">Confirm Password <span class="text-danger">*</span></label>
                      <div class="col-md-12">
                        <input type="password" placeholder="confirm password..." class="form-control form-control-fix" autocomplete="off" v-model="confirm_password" required />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Column -->
      </div>
      <!-- Row -->
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" data-bs-dismiss="modal" id="profileclose"><i class="fa fa-times"></i> Close</button>
      <button type="button" class="btn btn-info btn-fix" @click="checkForm"><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
// import VueJwtDecode from 'vue-jwt-decode'
import Swal from 'sweetalert2'
import api from '../../models/services'

export default {
  props: ['user'],
  data() {
    return {
      role_list: [],
      tab_active: 1,
      old_password: '',
      new_password: '',
      confirm_password: ''
    }
  },
  methods: {
    imgPreview(e) {
      const file = e.target.files[0]
      this.user.photo = URL.createObjectURL(file)
    },
    checkForm() {
      if (this.tab_active === 1) {
        var $myForm = $('#formProfile')
        if (!$myForm[0].checkValidity()) {
          $('#formProfile').addClass('was-validated')
        } else {
          this.updateProfile()
        }
      } else if (this.tab_active === 2) {
        var $myFormPass = $('#formResetPassword')
        if (!$myFormPass[0].checkValidity()) {
          $('#formResetPassword').addClass('was-validated')
        } else {
          this.changePassword()
        }
      }
    },
    getRole() {
      api.getRole(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.role_list = result.data
          } else {
            Swal.fire({
              title: result.message,
              text: 'There is a problem with your data, would you like to log out? ?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#F43131',
              confirmButtonText: 'Logout',
              cancelButtonText: 'Close',
              reverseButtons: true,
              customClass: 'Custom_Cancel'
            }).then(result => {
              if (result.isConfirmed) {
                this.logOut()
              } else {
                // eslint-disable-next-line no-undef
                $('#profileclose').click()
                this.OAuthToken()
              }
            })
          }
        },
        error => {
          this.alert_msg('error', 'Get Role', 'Role not be retrieved because ' + error.message)
          this.OAuthToken()
          // eslint-disable-next-line no-undef
          $('#profileclose').click()
        }
      )
    },
    updateProfile() {
      // eslint-disable-next-line no-undef
      $('#profileclose').click()
      // eslint-disable-next-line no-undef
      $('.preloader').fadeIn()
      var imagefile = document.querySelector('#profile_user')
      let formData = new FormData()
      if (imagefile.files.length > 0) {
        formData.append('photo', imagefile.files[0])
      } else {
        formData.append('photo', '')
      }
      // formData.append('username', this.user.username)
      formData.append('name', this.user.name)
      formData.append('surname', this.user.surname)
      formData.append('email', this.user.email)
      formData.append('phone', this.user.phone)
      formData.append('section', this.user.section)
      api.updateProfile(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.getProfile()
            this.alert_msg('success', 'Edit Profile', result.message)
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          } else {
            this.getProfile()
            this.alert_msg('warning', 'Edit Profile', result.message)
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          }
        },
        error => {
          this.getProfile()
          this.alert_msg('error', 'Edit Profile', error.message)
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut()
        }
      )
    },
    changePassword() {
      if (this.old_password !== '' && this.new_password !== '' && this.confirm_password !== '') {
        if (this.new_password === this.confirm_password) {
          Swal.fire({
            title: 'Change Password',
            text: 'When the password change is successful You must verify your new identity. Want to continue ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#26AD0B',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            reverseButtons: true
          }).then(result => {
            if (result.isConfirmed) {
              // eslint-disable-next-line no-undef
              $('#profileclose').click()
              // eslint-disable-next-line no-undef
              $('.preloader').fadeIn()
              const obj = {
                old_password: this.old_password,
                new_password: this.new_password
              }
              api.changePass(
                this.$store.state.URLHost,
                obj,
                this.header,
                result => {
                  if (result.response === true) {
                    this.alert_msg('success', 'Edit Profile', result.message)
                    this.logOut()
                  } else {
                    this.getProfile()
                    this.alert_msg('warning', 'Edit Profile', result.message)
                    // eslint-disable-next-line no-undef
                    $('.preloader').fadeOut()
                  }
                },
                error => {
                  this.getProfile()
                  this.alert_msg('error', 'Edit Profile', error.message)
                  // eslint-disable-next-line no-undef
                  $('.preloader').fadeOut()
                }
              )
            }
          })
        } else {
          this.alert_msg('warning', 'Change Password', 'Please enter a new password for the same.')
        }
      } else {
        this.alert_msg('warning', 'Change Password', 'Please fill out the information completely.')
      }
    }
  },
  mounted() {
    var myModalEl = document.getElementById('ProfileModal')
    myModalEl.addEventListener('hidden.bs.modal', event => {
      if (event.target.id === 'ProfileModal') {
        this.getRole()
        this.tab_active = 1
        this.old_password = ''
        this.new_password = ''
        // eslint-disable-next-line no-undef
        $('#profile_user').val('')
        // eslint-disable-next-line no-undef
        $('#formProfile').addClass('was-validated')
        $('#formResetPassword').addClass('was-validated')
      }
    })
    myModalEl.addEventListener('shown.bs.modal', event => {
      if (event.target.id === 'ProfileModal') {
        this.getRole()
        this.tab_active = 1
        this.old_password = ''
        this.new_password = ''
        // eslint-disable-next-line no-undef
        $('#profile_user').val('')
        // eslint-disable-next-line no-undef
        $('#formProfile').removeClass('was-validated')
        $('#formResetPassword').removeClass('was-validated')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/profile_modal.vue